import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';



const Layout = (props) => {

    const [mainContent, sidebar] = props.children;

    return (
        <div className="row ">
            <div className="main-content col-12 col-md-7 col-lg-8">
                {mainContent}
            </div>

            <div className="dashboard col-12 col-md-5 col-lg-4">
                {sidebar}
            </div>
        </div>);
};

const MainLayout = (props) => {
    return (<div>
        <NavMenu />
        <Container >            
            {props.children}
        </Container>
    </div>);
};


export { MainLayout, Layout };
